<template>
  <div class="edit-btn">
    <i v-show="showBtn" class="fas fa-pencil-alt edit-icon" @click="editProduct"></i>
  </div>
</template>

<script>
  export default {
    name: 'EditGridButton',
    methods: {
      editProduct() {
        this.$router.push({path: `/product/${this.params.data.id}`});
      }
    },
    computed: {
      showBtn() {
        return !this.params.node.rowPinned && this.params.data
      }
    }
  }
</script>

<style scoped>
  .edit-icon {
    font-size: 1.250rem;
    transform: rotateY(180deg);

  }
</style>



// WEBPACK FOOTER //
// src/components/common/EditGridButton.vue